/**
 * Created by Ramon Wenger on 06.07.18.
 * Copyright (c) 2018 Iterativ GmbH. All rights reserved.
 */
import { PaymentRequest, Promotion } from "./payment.models"
import { PaymentActionTypes } from "./payment.actions";
import { CustomAction } from "../actions/CustomAction";

export interface PaymentState {
    paymentRequest: PaymentRequest,
    promotion: Promotion,
    promotionErrors: Object;
    paymentUrl: string;
}

export const initialPaymentState: PaymentState = {
    paymentRequest: {
        merchantId: '',
        amount: '',
        currency: '',
        refno: '',
        sign: '',
        url: ''
    },
    promotion: {
        code: '',
        descriptionDe: '',
        descriptionFr: '',
        descriptionIt: ''
    },
    promotionErrors: null,
    paymentUrl: ''
};

export function reducer(state = initialPaymentState, action: CustomAction): PaymentState {
    switch (action.type) {
        case PaymentActionTypes.GET_PAYMENT_REQUEST_SUCCESS:
            return Object.assign({}, state, {
                paymentRequest: action.payload.datatransRequest,
                promotion: action.payload.promotion,
                promotionErrors: action.payload.error === 'invalid-code' ? {code: ['Der Code ist ungültig']} : initialPaymentState.promotionErrors,
                paymentUrl: action.payload.paymentUrl
            });

        case PaymentActionTypes.RESET_PAYMENT:
            return Object.assign({}, initialPaymentState);

        case PaymentActionTypes.SET_PROMOTION_ERRORS:
            return Object.assign({}, state, {
                promotionErrors: action.payload
            })

        default:
            return state;
    }
}

export function getPaymentRequest(state: PaymentState) {
    return state.paymentRequest;
}

export function getPromotion(state: PaymentState) {
    return state.promotion;
}

export function getPromotionErrors(state: PaymentState) {
    return state.promotionErrors;
}

export function getPaymentUrl(state: PaymentState) {
    return state.paymentUrl;
}
